
import { Vue, Component } from 'vue-property-decorator';
import loading from '@/components/loading.vue';

@Component({
    name: 'Jump',
    components: {
        loading,
    },
})
export default class Jump extends Vue {
    private timer: any = '';
    private mounted() {
        if (this.$route.query?.j) {
            this.timer = setTimeout(() => {
                location.href = decodeURIComponent(this.$route.query.j as string);
            }, 1000);
        }
    }
    private beforeDestroy() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
}
